// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2LEYV","label":"Completed_label__13lbK"};